// import { fromJS } from 'immutable';
import { types } from '../types';
import { createAction, createReducer } from '@reduxjs/toolkit';

// export const setMenuSelection = (menuHierarchy) => {
//   return {
//     type: types.SET_MENU_SELECTION,
//     menuHierarchy
//   };
// };

const menuSelected = createAction(types.SET_MENU_SELECTION);

const initialState = { 
  menuSelected: []
};

const MenuReducer = createReducer(initialState, (builder) => {
  builder
  .addCase(menuSelected, (state,action) => {
    state.menuSelected = action.menuHierarchy;
  })
  .addDefaultCase(() => {});
});

export default MenuReducer;
